<form class="input-send" [formGroup]="sendForm">
  <input id="input-send-input" class="input-send-input" pInputText formControlName="field"
    placeholder="Renseignez votre mail"
    [ngClass]="{ 'ng-invalid': sendForm.controls.field.invalid && sendForm.controls.field.touched }">
  @if (sendForm.controls.field.invalid && sendForm.controls.field.touched) {
    <field-error text="Format incorrect"></field-error>
  }
  <div class="input-send-button" (click)="submit()">
    <fa-icon [icon]="faArrowRight"></fa-icon>
  </div>
</form>
